(() => {
    'use strict';

    real.events.on('uploadedfile:stored', notification => {
        if (notification?.object?.uploadedfile?.upload_process_metadata?.token) {
            const token = notification.object.uploadedfile.upload_process_metadata.token;
            if ($('.widget-video[data-upload-token="' + token + '"]').length > 0) {
                getUploadedFileAndPreview($('.widget-video[data-upload-token="' + token + '"]'), notification.object.uploadedfile.id);
            } else if ($('.widget-video[data-changing-poster-token="' + token + '"]').length > 0) {
                const widget = $('.widget-video[data-changing-poster-token="' + token + '"]');
                const widgetId = widget.data('widget-id');
                savePosterImg(widget, notification.object.uploadedfile.id);

                // This is needed because when we change the poster image by getting a frame from the video,
                // we need to wait the uploaded file to be stored before we can close the modal.
                if ($('.modal[data-widget-id="' + widgetId + '"]').length > 0) {
                    howspace.components.modal.close($('.modal[data-widget-id="' + widgetId + '"]'));
                }
            }
        }
    });

    const getUploadedFileAndPreview = (widget, uploadedFileId) => {
        const currentVideoWrapper = widget.find('.current-video-wrapper');

        if (currentVideoWrapper.find('.howspace-video-player-initialized').length > 0) {
            howspace.components.videoPlayer.destroy(widget);
        }

        if (widget.find('.upload-video-wrapper').is(':visible')) {
            howspace.animate(widget.find('.upload-video-wrapper'), 'slideUp', 350, () => {
                widget.find('.upload-video-wrapper').removeAttr('style').addClass('d-none');
                currentVideoWrapper.find('.oembed-video-preview').addClass('d-none');
                currentVideoWrapper.find('.uploaded-video-preview').removeClass('d-none');
                howspace.animate(currentVideoWrapper, 'slideDown', 350, () => {
                    currentVideoWrapper.removeAttr('style').removeClass('d-none');
                    currentVideoWrapper.find('.change-video-poster-image-btn, .delete-video-btn').removeClass('d-none');

                    const saveBtn = widget.find('.save-widget-btn');
                    howspace.components.toolTip.enable(saveBtn);
                    howspace.components.toolTip.update(saveBtn, howspace.translate('common_remember_to_save'));
                    saveBtn.trigger('focus');
                });
            });
        }

        widget.find('.widget-footer .btn').prop('disabled', false);

        const url = real.baseUri + '/uploadedfile/' + uploadedFileId + '/view';

        currentVideoWrapper.find('.howspace-video-player')
            .dataAndAttr('mp4-url', url)
            .dataAndAttr('uploadedfile-id', uploadedFileId)
            .dataAndAttr('is-stored', true)
            .removeAttr('data-poster-file-url')
            .removeDataAndAttr('poster-file-url')
            .removeDataAndAttr('background-url')
            .css('background-image', 'none');

        howspace.components.videoPlayer.init(widget);

        // Change the url of the change poster image button.
        const changePosterImage = currentVideoWrapper.find('.change-video-poster-image-btn');
        if (changePosterImage.length > 0) {
            const changePosterImageModalData = changePosterImage.data('modal');
            changePosterImageModalData.url = changePosterImage.data('modal-url') + '?uploaded_file_id=' + uploadedFileId;
            changePosterImage.dataAndAttr('modal', changePosterImageModalData);
        }

        widget.dataAndAttr('local-video-file-id', uploadedFileId);

        if (widget.find('.upload-video-wrapper input[name="local_video_file"]').length > 0) {
            widget.find('.upload-video-wrapper input[name="local_video_file"]').val(uploadedFileId);
        } else {
            widget.find('.upload-video-wrapper').append('<input type="hidden" name="local_video_file" value="' + uploadedFileId + '">');
        }

        widget.find('.change-video-poster-image-btn').dataAndAttr('file-type', 'video');

        // Show the subtitle area.
        widget.find('.custom-subtitles').removeClass('d-none');
        widget.find('.subtitle-no-support').addClass('d-none');
        widget.find('.subtitle-container').removeClass('d-none');
    };

    const handleFileUploadCompleted = (modal, modalOpener, uploadedFiles) => {
        const file = uploadedFiles[0];
        const widget = $(modalOpener.closest('.widget-video'));
        if (widget.length === 0 || !file || !file.id) {
            return;
        }

        getUploadedFileAndPreview(widget, file.id);
        howspace.components.modal.close(modal);
    };

    /**
     *
     * @param {*} modal
     * @param {*} modalOpener
     */
    const initFileUploaderModal = (modal, modalOpener) => {
        modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
            handleFileUploadCompleted(modal, modalOpener, e.detail.uploadedFiles);
        });
    };

    let recordTimerInterval = null;
    /**
     * @param {*} widget
     */
    const countDownAndStartRecording = (widget) => {
        widget.find('.widget-footer .btn').prop('disabled', true);

        const uploadOrRecordButtons = widget.find('.upload-or-record-buttons');
        const recordingContainer = widget.find('.recording');
        const recordingButtonsMessage = recordingContainer.find('.recording-buttons-message');
        const recordingCountdown = recordingContainer.find('.recording-countdown');
        const recordingPreview = recordingContainer.find('.recording-preview');
        const recordTimer = recordingContainer.find('.record-timer');
        const recordingLoader = recordingContainer.find('.howspace-loader');

        recordingContainer.removeClass('d-none');
        recordingLoader.removeClass('d-none');
        uploadOrRecordButtons.addClass('d-none');
        recordingPreview.addClass('d-none');
        recordingButtonsMessage.addClass('d-none');
        recordingCountdown.addClass('d-none');

        if (recordTimerInterval) {
            clearInterval(recordTimerInterval);
        }

        const onMediaSuccess = (stream, type) => {
            recordingLoader.addClass('d-none');
            recordingPreview.addClass('blur');
            recordingPreview.removeClass('d-none');

            setTimeout(() => {
                const previewRect = recordingPreview[0].getBoundingClientRect();
                if (previewRect.top < $('#top').height() || previewRect.bottom > window.innerHeight) {
                    // Either the top or the bottom of the recording preview is not fully visible, scroll to it.
                    howspace.scroller.scrollToElement(recordingPreview);
                }
            }, 100);

            // Fade in the countdown and start the countdown animation
            howspace.animate(recordingCountdown, 'fadeIn', 350, () => {
                recordingCountdown.removeAttr('style').removeClass('d-none')
                recordingCountdown.prop('countdown', 4).animate(
                    { countdown: 0 },
                    {
                        duration: 4000,
                        easing: 'linear',
                        step: now => {
                            recordingCountdown.find('.count-down-text').html(Math.ceil(now));
                        },
                        complete: () => {
                            recordingPreview.removeClass('blur');
                            recordTimer.html('00:00');
                            recordingCountdown.addClass('d-none');
                            recordingButtonsMessage.removeClass('d-none');

                            const updateInterval = 1000;
                            let startTime = 0;
                            recordTimerInterval = setInterval(() => {
                                startTime += updateInterval;
                                const { hours, minutes, seconds } = howspace.mediaRecorder.calculateTime(startTime);
                                const format = howspace.mediaRecorder.formatTime(hours, minutes, seconds);
                                recordTimer.html(format);
                            }, updateInterval);

                            howspace.mediaRecorder.start(stream, type);
                        }
                    }
                );
            });
        }

        const onMediaError = () => {
            uploadOrRecordButtons.removeClass('d-none');
            recordingContainer.addClass('d-none');
            recordingCountdown.addClass('d-none');
            recordingLoader.addClass('d-none');

            real.notification.show(howspace.translate('fileuploader_video_recording_error'), 'danger');
        };

        howspace.mediaRecorder.startVideo(recordingPreview[0], onMediaSuccess, onMediaError);
    };

    /**
     * @param {*} widget
     */
    const cancelRecording = (widget) => {
        const uploadOrRecordButtons = widget.find('.upload-or-record-buttons');
        const recordingContainer = widget.find('.recording');

        howspace.animate(recordingContainer, 'slideUp', 350, () => {
            recordingContainer.removeAttr('style');
            recordingContainer.addClass('d-none');
            uploadOrRecordButtons.removeClass('d-none');

            howspace.mediaRecorder.stop(() => {
                if (recordTimerInterval) {
                    clearInterval(recordTimerInterval);
                }
                widget.find('.widget-footer .btn').prop('disabled', false);
            });
        });
    };

    /**
     * @param {*} widget
     */
    const uploadRecording = (widget) => {
        const recordingContainer = widget.find('.recording');
        recordingContainer.find('.howspace-loader').removeClass('d-none');
        recordingContainer.find('.recording-buttons-message').addClass('d-none');
        recordingContainer.find('.recording-countdown').addClass('d-none');
        recordingContainer.find('.recording-preview').addClass('d-none');

        howspace.mediaRecorder.stop(blob => {
            if (recordTimerInterval) {
                clearInterval(recordTimerInterval);
            }

            if (blob && blob.size > 0) {
                try {
                    const extension = howspace.mediaRecorder.getFileExtension(blob);

                    const formData = new FormData();
                    const token = real.uid();

                    formData.append(
                        'upload_process_metadata',
                        JSON.stringify({ token })
                    );

                    formData.append(
                        'file',
                        blob,
                        `video-recording${extension}`
                    );

                    formData.append('file_type', blob.type);

                    real.ajax(howspace.widgets.getApiUrl(widget) + '/uploadedfiles', {
                        type: 'POST',
                        data: formData,
                        dataType: 'json',
                        contentType: false,
                        processData: false,
                        success: () => {
                            widget.dataAndAttr('upload-token', token);
                        }
                    });
                } catch (error) {
                    howspace.animate(recordingContainer, 'slideUp', 350, () => {
                        recordingContainer.removeAttr('style');
                        recordingContainer.addClass('d-none');
                        widget.find('.upload-or-record-buttons').removeClass('d-none');
                    });
                    real.notification.show(
                        howspace.translate('fileuploader_recording_error'),
                        'danger'
                    );
                }
            }
        });
    };

    const getViewStatisticsAndRenderChart = (widget, modal) => {
        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/views?grouped=1', {
            type: 'GET',
            success: (response) => {
                modal.find('.howspace-loader').remove();
                if (response.users_started_to_watch_video) {
                    const headerTitle = modal.find('.modal-header .modal-title').text();
                    modal.find('.modal-header .modal-title').html(headerTitle + ' (' + response.users_started_to_watch_video + ')');
                }

                const percentagesArr = [];
                let percentage = 0;
                while (percentage <= 100) {
                    percentagesArr.push(percentage + '%');
                    percentage++;
                }

                const brandColor = howspace.components.colorPicker.getPalette()[0];
                const backgroundColor = '#f0edfa';

                new Chart(modal.find('#watching-statistics-canvas')[0].getContext('2d'), {
                    type: 'line',
                    data: {
                        labels: percentagesArr,
                        datasets: [{
                            label: modal.data('users-translation'),
                            backgroundColor: backgroundColor,
                            borderColor: brandColor,
                            pointRadius: 0,
                            pointHitRadius: 10,
                            fill: 'start',
                            data: Object.keys(response.users_watched_video_by_percentage).map(key => response.users_watched_video_by_percentage[key])
                        }]
                    },
                    options: {
                        responsive: true,
                        plugins: {
                            title: { display: false }
                        },
                        scales: {
                            x: {
                                display: true,
                                ticks: {
                                    maxTicksLimit: 11
                                }
                            },
                            y: {
                                display: true,
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 1
                                }
                            }
                        }
                    }
                });
            }
        });
    }
    /**
     * @param {*} modal
     * @param {*} modalOpener
     */
    const initWatchingStatisticsModal = (modal, modalOpener) => {
        modal = $(modal);
        const widget = $(modalOpener.closest('.widget-video'));

        modal.on(howspace.components.modal.MODAL_OPENED, () => {
            howspace.chart.init(() => {
                getViewStatisticsAndRenderChart(widget, modal);
            });
        });
    };

    const sendViewMinimumDelayInSeconds = 10;
    const sendView = (widget, seconds) => {
        const dataPayload = {
            watched_percentage: Math.min(100, Math.ceil(seconds / widget.data('local-video-file-duration') * 100))
        };

        if (dataPayload.watched_percentage >= 90) {
            howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
        }

        if (widget.data('last-view-sent-at') && widget.data('last-view-sent-at') > Date.now() - sendViewMinimumDelayInSeconds * 1000) {
            return;
        }

        widget.data('last-view-sent-at', Date.now());
        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/views', {
            type: 'POST',
            data: JSON.stringify(dataPayload)
        });
    };

    const savePosterImg = (widget, posterId) => {
        if (widget.find('.upload-video-wrapper input[name="poster_image_file"]').length > 0) {
            widget.find('.upload-video-wrapper input[name="poster_image_file"]').val(posterId);
        } else {
            widget.find('.upload-video-wrapper').append('<input type="hidden" name="poster_image_file" value="' + posterId + '">');
        }
        widget.find('.howspace-video-player').css(
            'background-image', 'url("' + real.baseUri + '/uploadedfile/' + posterId + '/view")'
        );

        widget.find('.howspace-video-player').css(`background-image`, `url("${real.baseUri}/uploadedfile/${posterId}/view")`);

        widget.find('.change-video-poster-image-btn').dataAndAttr('changed-poster-image-id', posterId);
        widget.find('.change-video-poster-image-btn').dataAndAttr('removed-poster-image-id', false);
    };

    const initPosterImageFileUploaderModal = (modal, modalOpener) => {
        modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
            const file = e.detail.uploadedFiles[0];
            const widget = $('.widget-video[data-widget-id="' + $(modalOpener).data('widget-id') + '"]');
            if (widget.length === 0 || !file || !file.id) {
                return;
            }
            if (widget.data('widget-mode') !== 'edit') {
                return;
            }
            savePosterImg(widget, file.id)
            howspace.components.modal.close(modal);
        });
    };

    const checkVideoUrl = (widget, url) => {
        real.ajax.json(real.baseUri + '/api/videooembeds', {
            type: 'GET',
            data: { url: url },
            success: response => {
                const currentVideoWrapper = widget.find('.current-video-wrapper');
                const oEmbedPreview = currentVideoWrapper.find('.oembed-video-preview');
                const previewPlayerWrapper = oEmbedPreview.find('.howspace-oembed-responsive');
                const previewPlayer = oEmbedPreview.find('.howspace-oembed');

                if (previewPlayer.is('.howspace-oembed-initialized')) {
                    howspace.components.oembed.destroy(previewPlayer);
                }

                previewPlayer
                    .dataAndAttr('oembed', response)
                    .css('background-image', 'url("' + response.thumbnail_url + '")');

                howspace.components.oembed.init(previewPlayer);

                // Update video url input value.
                widget.find('input[name="video_url"]').val(response.url);

                if (response.width && !/%/.test(response.width) && response.height && !/%/.test(response.height)) {
                    previewPlayerWrapper.removeClass('embed-responsive-16by9');
                    previewPlayerWrapper.css('padding-top', (response.height / response.width * 100) + '%');
                } else {
                    previewPlayerWrapper.addClass('embed-responsive-16by9');
                    previewPlayerWrapper.css('padding-top', 0);
                }

                if (widget.find('.upload-video-wrapper').is(':visible')) {
                    howspace.animate(widget.find('.upload-video-wrapper'), 'slideUp', 350, () => {
                        widget.find('.upload-video-wrapper').removeAttr('style').addClass('d-none');
                        currentVideoWrapper.find('.current-video-wrapper .uploaded-video-preview').addClass('d-none');
                        currentVideoWrapper.find('.oembed-video-preview').removeClass('d-none');
                        howspace.animate(currentVideoWrapper, 'slideDown', 350, () => {
                            currentVideoWrapper.removeAttr('style').removeClass('d-none');
                            currentVideoWrapper.find('.change-video-poster-image-btn, .delete-video-btn').removeClass('d-none');
                        });
                    });
                }

                widget.find('input[name="local_video_file"]').remove();
                widget.find('.change-video-poster-image-btn').dataAndAttr('file-type', 'oembed');

                real.button.reset(widget.find('.save-widget-btn'), widget);

                // Hide the subtitle area.
                hideSubtitleArea(widget);
            },
            showErrorNotification: false,
            logError: false,
            error: () => {
                const videoUrlInput = widget.find('.video-url-input');
                howspace.form.markInvalidField(videoUrlInput);
                real.button.reset(widget.find('.save-widget-btn'), widget);
                videoUrlInput.trigger('focus');
            }
        });
    };

    /**
     *
     * @param {*} modal
     * @param {*} modalOpener
     */
    const initSubtitleFileUploaderModal = (modal, modalOpener) => {
        modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
            handleSubtitleFileUploadCompleted(modal, modalOpener, e.detail.uploadedFiles)
        });
    };

    const handleSubtitleFileUploadCompleted = (modal, modalOpener, uploadedFiles) => {
        const file = uploadedFiles[0];
        const widget = $(modalOpener.closest('.widget-video'));
        if (widget.length === 0 || !file || !file.id) {
            return;
        }

        const subtitleWrapper = $(modalOpener).closest('.subtitle-item');
        subtitleWrapper.find('input[name="subtitle_file"]').val(file.id);
        $(modalOpener).find('.btn-text').text(howspace.translate('video_change_subtitle_file'));

        howspace.components.modal.close(modal);
    };

    const isValidSubtitle = (subtitle) => {
        if (!subtitle.language || !subtitle.name || !subtitle.subtitle_file) {
            return false;
        }

        return true;
    };

    const hideSubtitleArea = (widget) => {
        const subtitles = widget.find('.custom-subtitles');
        subtitles.addClass('d-none');
        subtitles.find('.subtitle-item').remove();

        widget.find('.download-auto-subtitle-btn').addClass('d-none');
        widget.find('.subtitle-container').addClass('d-none');
        widget.find('.subtitle-no-support').removeClass('d-none');
    };

    const initShareModal = (modal) => {
        modal = $(modal);

        const widgetId = $(modal).data('widget-id');
        const widget = $('.widget-video[data-widget-id="' + widgetId + '"]');
        if (widget.length === 0) {
            return;
        }

        const videoPlayer = widget.find('.howspace-video-player');
        if (videoPlayer.length === 0) {
            return;
        }

        if (videoPlayer.data('current-time')) {
            const timeButton = modal.find('.shared-link-btn[data-with-time="1"]');
            const radioWrapper = timeButton.closest('.howspace-form-radio-button');
            const startAtSeconds = Math.floor(videoPlayer.data('current-time')) || 0;

            timeButton.dataAndAttr('start-at-seconds', startAtSeconds);
            timeButton.val(startAtSeconds);

            radioWrapper.find('.howspace-form-label-text span').text(howspace.translate('video_copy_link_to_current_moment', {
                time: howspace.mediaShare.formatTimeInput(startAtSeconds)
            }));
            timeButton.prop('disabled', startAtSeconds === 0);
            timeButton.prop('checked', startAtSeconds > 0);
            radioWrapper.toggleClass('disabled', startAtSeconds === 0);
        }

        modal.find('.copy-link-btn').on('click', async (e) => {
            const checkedRadio = modal.find('.shared-link-btn:checked');
            const sharedLink = howspace.mediaShare.getSharedLink(checkedRadio);

            await real.copyToClipboard(sharedLink, () => {
                howspace.components.modal.close(modal);
                howspace.dispatchEvent(widget, howspace.widgets.video.VIDEO_SHARE_LINK_COPIED, {
                    sharedLink: sharedLink
                });
            }, () => {
                howspace.components.modal.close(modal);
                howspace.dispatchEvent(widget, howspace.widgets.video.VIDEO_SHARE_LINK_COPY_FAILED);
            });
        });
    };

    // The first request for a freshly uploaded poster image returns 202 while the server is still creating
    // the web version of it, and a CSS background-image that fails once is never retried by the browser.
    // Once the server reports the image ready, clear the background and load the poster again.
    real.events.on('uploadedfile:image:manipulated', notification => {
        const posterFileId = notification?.object?.uploadedfile?.id;
        if (!posterFileId) {
            return;
        }

        $('.widget-video[data-poster-file-id="' + posterFileId + '"]').each(function () {
            const widget = $(this);
            const posterUrl = widget.data('poster-image-url');
            const posterElements = widget.find('.howspace-video-player, .howspace-oembed.video');
            if (!posterUrl || posterElements.length === 0) {
                return;
            }

            posterElements.css('background-image', 'none');
            real.image.load(posterUrl, () => {
                posterElements.css('background-image', `url("${posterUrl}")`);
            });
        });
    });

    howspace.widgets.video = {
        VIDEO_SHARE_LINK_COPIED: 'video-share-link-copied',
        VIDEO_SHARE_LINK_COPY_FAILED: 'video-share-link-copy-failed',
        initView: widget => {
            widget.find('.record-video-btn').on('click', () => {
                countDownAndStartRecording(widget);
            });

            widget.find('.cancel-recording-btn').on('click', () => {
                cancelRecording(widget);
            });

            widget.find('.upload-recording-btn').on('click', () => {
                uploadRecording(widget);
            });

            widget.on(howspace.components.videoPlayer.VIDEO_PLAY, e => {
                sendView(widget, Math.ceil(e.detail.player.currentTime()));
            });

            widget.on(howspace.components.videoPlayer.VIDEO_PAUSE, e => {
                widget.removeData('last-view-sent-at');
                sendView(widget, Math.ceil(e.detail.player.currentTime()));
            });

            widget.on(howspace.components.videoPlayer.VIDEO_TIME_UPDATED, e => {
                if (!e.player.paused()) {
                    sendView(widget, Math.ceil(e.detail.player.currentTime()));
                }
            });

            widget.on(howspace.components.videoPlayer.VIDEO_ENDED, e => {
                widget.removeData('last-view-sent-at');
                sendView(widget, Math.ceil(e.detail.player.currentTime()));
            });

            widget.on(howspace.widgets.video.VIDEO_SHARE_LINK_COPIED, e => {
                real.notification.show(howspace.translate('video_shared_link_copied'), 'success');
            });

            widget.on(howspace.widgets.video.VIDEO_SHARE_LINK_COPY_FAILED, () => {
                real.notification.show(howspace.translate('common_failed_to_copy_link'), 'danger');
            });

            howspace.transcript.init(widget);
        },
        destroyView: widget => {
            howspace.transcript.destroy(widget);
            howspace.components.oembed.destroy(widget);
            howspace.components.oembed.destroyVideoPlayer(widget.find('.howspace-oembed.video'));
        },
        initEdit: widget => {
            const saveBtn = widget.find('.save-widget-btn');

            widget.find('.video-url-input').on('input', e => {
                const input = $(e.target);
                howspace.form.clearInvalidField(input);
            });

            widget.find('.video-url-input').on('keyup', e => {
                const input = $(e.target);

                if (e.keyCode === 13) {
                    real.button.loading(saveBtn, widget);

                    const url = input.val().trim();
                    if (url === '') {
                        return;
                    }

                    checkVideoUrl(widget, url);
                }
            });

            widget.find('.video-url-input').on('paste', e => {
                const input = $(e.target);

                setTimeout(function () {
                    real.button.loading(saveBtn, widget);

                    const url = input.val().trim();
                    if (url === '') {
                        return;
                    }

                    checkVideoUrl(widget, url);
                }, 0);
            });

            widget.find('.delete-video-btn').on('click', () => {
                const currentVideoWrapper = widget.find('.current-video-wrapper');
                const uploadVideoWrapper = widget.find('.upload-video-wrapper');
                const posterImageFile = widget.find('.poster-image-uploader');
                howspace.animate(currentVideoWrapper, 'slideUp', 350, () => {
                    howspace.components.videoPlayer.destroy(widget);
                    howspace.components.oembed.destroy(widget);

                    currentVideoWrapper.removeAttr('style').addClass('d-none');
                    currentVideoWrapper.find('.uploaded-video-preview').addClass('d-none');
                    currentVideoWrapper.find('.oembed-video-preview').addClass('d-none');
                    currentVideoWrapper.find('.change-video-poster-image-btn, .delete-video-btn').addClass('d-none');

                    if (uploadVideoWrapper.find('input[name="local_video_file"]').length > 0) {
                        uploadVideoWrapper.find('input[name="local_video_file"]').remove();
                    } else {
                        uploadVideoWrapper.append('<input type="hidden" name="local_video_file" value=""/>');
                    }

                    posterImageFile.find('.delete-btn').trigger('click');

                    uploadVideoWrapper.find('input[name="video_url"]').val('');

                    uploadVideoWrapper.find('.recording').addClass('d-none');

                    widget.removeDataAndAttr('local-video-file-id');

                    howspace.animate(uploadVideoWrapper, 'slideDown', 350, () => {
                        uploadVideoWrapper.removeAttr('style').removeClass('d-none');
                        uploadVideoWrapper.find('.upload-or-record-buttons').removeClass('d-none');
                    });

                    // Hide the subtitle area.
                    hideSubtitleArea(widget);
                });
                widget.find('.change-video-poster-image-btn').dataAndAttr('removed-poster-image-id', true);
            });

            widget.find('.record-video-btn').on('click', () => {
                countDownAndStartRecording(widget);
            });

            widget.find('.cancel-recording-btn').on('click', () => {
                cancelRecording(widget);
            });

            widget.find('.upload-recording-btn').on('click', () => {
                uploadRecording(widget);
            });

            widget.on('change', '.subtitle-language', e => {
                const subtitleLanguage = $(e.currentTarget);
                const subtitleName = subtitleLanguage.closest('.subtitle-item').find('.subtitle-name');

                // Autofill subtitle name if empty
                if (!subtitleName.val().trim()) {
                    subtitleName.val(subtitleLanguage.find('option:selected').text());
                }
            });

            widget.find('.add-subtitle-btn').on('click', e => {
                const sortableList = widget.find('.custom-subtitles  .howspace-sortable-list');
                howspace.components.sortableList.addItem(sortableList);
            });

            widget.on('click', '.delete-subtitle-btn', e => {
                const subtitleItem = $(e.currentTarget).closest('.subtitle-item');
                howspace.animate(subtitleItem, 'slideUp', 350, () => {
                    subtitleItem.remove();
                });
            });

            widget.on('change', '.subtitle-default input[name="is_default"]', e => {
                const checkbox = $(e.currentTarget);
                const isDefault = checkbox.is(':checked');

                if (isDefault) {
                    widget.find('.subtitle-default input[name="is_default"]').not(checkbox).prop('checked', false);
                }
            });

        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            if (widget.data('local-video-file-id')) {
                const validSubtitles = [];
                const invalidSubtiles = [];
                widget.find('.subtitle-item').each(function () {
                    const payload = real.form.getDataPayload($(this));

                    // Push those subtitles that are invalid to the invalidSubtiles array.
                    if (!isValidSubtitle(payload)) {
                        invalidSubtiles.push($(this));
                        return;
                    }

                    payload.uploaded_file = widget.data('local-video-file-id');
                    validSubtitles.push(payload);
                });

                // Mark invalid subtitles.
                if (invalidSubtiles.length > 0) {
                    invalidSubtiles.forEach(subtitle => {
                        subtitle.addClass('invalid');
                    });
                    return false;
                }

                // Add the valid subtitles to the data payload.
                dataPayload.subtitles = validSubtitles;
                dataPayload.default_subtitle = null;
                if (widget.find('.subtitle-default input[name="is_default"]:checked').length > 0) {
                    dataPayload.default_subtitle = widget.find('.subtitle-default input[name="is_default"]:checked').val();
                }
            }

            return dataPayload;
        },
        error: (response, widget, dataPayload) => {
            real.button.reset(widget.find('.save-widget-btn'), widget);
            real.ajax.loopErrors(response, function (error) {
                if (error.code === 4002 && error.key.startsWith('invalid_property_value_not_subtitle')) {
                    // Get the subtitle id from the error key.
                    const subtitleId = error.key.split(':').pop();
                    const subtitleItem = widget.find('input[name="subtitle_file"][value="' + subtitleId + '"]').closest('.subtitle-item');

                    if (subtitleItem.length > 0) {
                        subtitleItem.addClass('invalid');
                    }
                }
            });
        },
        initFileUploaderModal: initFileUploaderModal,
        initWatchingStatisticsModal: initWatchingStatisticsModal,
        initPosterImageFileUploaderModal: initPosterImageFileUploaderModal,
        initSubtitleFileUploaderModal: initSubtitleFileUploaderModal,
        initShareModal: initShareModal
    };
})();
